import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Switch, FormControlLabel
} from '@mui/material';

const EditDealerDialog = ({ dealer, onClose, onSave }) => {
    const [edited, setEdited] = useState({ ...dealer });

    return (
        <Dialog open onClose={onClose}>
            <DialogTitle>Händler bearbeiten</DialogTitle>
            <DialogContent>
                <TextField label="ID" value={edited.id} fullWidth disabled margin="dense" />
                <TextField label="Name" value={edited.name} fullWidth margin="dense"
                    onChange={(e) => setEdited({ ...edited, name: e.target.value })} />
                <TextField label="Vorname" value={edited.firstName} fullWidth margin="dense"
                    onChange={(e) => setEdited({ ...edited, firstName: e.target.value })} />
                <TextField label="Email" value={edited.email} fullWidth margin="dense"
                    onChange={(e) => setEdited({ ...edited, email: e.target.value })} />
                <TextField label="Telefon" value={edited.phoneNumber} fullWidth margin="dense"
                    onChange={(e) => setEdited({ ...edited, phoneNumber: e.target.value })} />
                <TextField label="Adresse" value={edited.address} fullWidth margin="dense"
                    onChange={(e) => setEdited({ ...edited, address: e.target.value })} />
                <TextField label="Lizenzen" type="number" value={edited.licenseCount} fullWidth margin="dense"
                    onChange={(e) => setEdited({ ...edited, licenseCount: parseInt(e.target.value) })} />
                <FormControlLabel
                    control={
                        <Switch checked={edited.isMaster}
                            onChange={(e) => setEdited({ ...edited, isMaster: e.target.checked })} />
                    }
                    label="Ist Master?"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button onClick={() => onSave(edited)} variant="contained">Speichern</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditDealerDialog;
